import { useEffect } from 'react';

import { useGetMedicalDocumentByIdQuery } from '@app/api/MedicalDocuments';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

interface UseMedicalDocumentViewProps {
  documentId: number | null;
}

export const useMedicalDocumentView = ({
  documentId,
}: UseMedicalDocumentViewProps) => {
  const { activeBranchId: ActiveBranchId } = useUserPrint();
  const { showNotification } = useNotification();

  const {
    data: document,
    isFetching,
    error,
  } = useGetMedicalDocumentByIdQuery(
    { ActiveBranchId, id: documentId ?? 0 },
    { skip: !ActiveBranchId || !documentId }
  );

  useEffect(() => {
    if (error) {
      showNotification(handleCatchError(error));
    }
  }, [error, showNotification]);

  return { document, isLoading: isFetching };
};
